module.exports = __webpack_public_path__ + "static/foodFlockMock-21c52b73e1e03213c7a9d2d7ef844c0a.jpeg";